/**
 * HLF Mobile Drawer — Accordion & Auto-close Logic
 * Separated from hlf-header.js for lazy loading.
 *
 * Features:
 *   - Single-open accordion (only one Level 1 open at a time)
 *   - Auto-close drawer on nav link click
 *   - Overlay click-to-close (real DOM element)
 *   - Search trigger delegates to hlf-header.js event system
 */
(function () {
  'use strict';

  function initDrawer() {
    const drawer = document.querySelector('.hlf-drawer');
    if (!drawer) return;

    const header = document.querySelector('.hlf-header');

    // Single-open accordion: when a Level 1 opens, close siblings
    drawer.addEventListener('toggle', function (e) {
      var details = e.target;
      if (!details.matches('.hlf-drawer__accordion:not(.hlf-drawer__accordion--nested)')) return;
      if (!details.open) return;

      var allL1 = drawer.querySelectorAll('.hlf-drawer__accordion:not(.hlf-drawer__accordion--nested)[open]');
      for (var i = 0; i < allL1.length; i++) {
        if (allL1[i] !== details) allL1[i].removeAttribute('open');
      }
    }, true);

    // Auto-close drawer when a regular nav link is clicked
    drawer.addEventListener('click', function (e) {
      var link = e.target.closest('a.hlf-drawer__item--link, a.hlf-drawer__subitem, a.hlf-drawer__link--l3');
      if (!link) return;

      setTimeout(function () {
        var summary = header && header.querySelector('header-drawer details summary');
        if (summary) summary.click();
      }, 120);
    });

    // Overlay click-to-close: when the real overlay element is clicked, close the drawer
    var overlay = document.querySelector('.hlf-drawer__overlay');
    if (overlay) {
      function closeDrawerViaOverlay(e) {
        e.preventDefault();
        e.stopPropagation();
        // Find the header-drawer summary to trigger Dawn's standard close flow
        var headerDrawer = header && header.querySelector('header-drawer details summary');
        if (!headerDrawer) {
          headerDrawer = document.querySelector('header-drawer details summary');
        }
        if (headerDrawer) headerDrawer.click();
      }
      overlay.addEventListener('click', closeDrawerViaOverlay);
      // iOS requires touchend for reliable tap handling on non-interactive elements
      overlay.addEventListener('touchend', function (e) {
        e.preventDefault();
        closeDrawerViaOverlay(e);
      }, { passive: false });
      // Prevent background scrolling when dragging/swiping on the overlay
      overlay.addEventListener('touchmove', function (e) {
        e.preventDefault();
      }, { passive: false });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawer);
  } else {
    initDrawer();
  }
})();

